import { environment } from '../../../environments/environment';
import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { LocalStorageService } from 'angular-2-local-storage';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
//import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { StoreConfig } from '../../shared/interfaces/store-config.interface';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/internal/operators';
import { Language } from 'src/app/shared/interfaces/language.interface';
import { SharedConstants } from 'src/app/shared/constants/shared.constants';

@Injectable()
export class AppTranslateService implements TranslateLoader, OnInit {
    country: any;
    defaultLanguage: any;
    globalLanguage: any;
    constructor(private http: HttpClient, private _localStorage: LocalStorageService) {

    }
    ngOnInit() {

    }

    /**
     * To get the translations of selected language file
     * @param  {any} language
     * @returns Observable
     */
    getTranslation(language: any): Observable<any> {
        language = language || 'en-US';
        try {
            language = JSON.parse(language);
        } catch (e) {
            language = language;
        }
        const store: StoreConfig = this._localStorage.get(CacheKey.StoreConfiguration);
        const cookieService: CookieService = new CookieService(document);
        this.country = cookieService.get(CacheKey.countryCode) || 'usa';
        let languageUrl: string = '';
        if (store) {
            if (store.languages && language.split('-').length > 2) {
                const storeLanguage: Language = store.languages.find(x => x.cultureName.toLowerCase() === language.toLowerCase());
                language = storeLanguage && storeLanguage.cultureName ? storeLanguage.cultureName : language;
            }
            languageUrl = environment.cdnURL + '/portals/corporate/template1/json/'
                + store.homeIsocodeThree + '/' + language + '.json';
        }
        const standAlonePage = SharedConstants.EVENT_PAGES.find((page: string) => {
            return window.location.href.toLowerCase().indexOf(page.toLowerCase()) > -1;
        });
        if (!store || standAlonePage) {
            languageUrl = environment.cdnURL + '/portals/corporate/template1/json/USA/en-US.json';
        }
        return this.http
             .get(languageUrl)
            //   .get(environment.uiTemplateBaseUrl + '/test/USA/en-US.json')
              .pipe(catchError(this.handleErrorObservable));
        
    }

    // /**
    //  * if selected language translation file is not found then use default lang file
    //  */
    // fallbackToDefaultLanguage() {
    //     this.defaultLanguage = this._localStorage.get('DefaultLanguage');
    //     const languageUrl: string = environment.cdnURL + '/portals/corporate/template1/json/'
    //         + this.country.toUpperCase() + '/' + this.defaultLanguage + '.json';
    //     return this.http
    //         .get(languageUrl)
    //         .map((res: Response) => res.json())
    //         .catch((error: any) => {
    //             return Observable.throw(error.message || error);
    //         });
    // }

    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error.message || error);
    }
}
